import { useTheme, useMediaQuery } from "@mui/material";

export interface ResponsiveConfig {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  getColumnWidth: (baseWidth: number, mobileWidth?: number) => number;
  getPageSize: () => number;
  getCardSpacing: () => number;
}

export const useResponsiveConfig = (): ResponsiveConfig => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const getColumnWidth = (baseWidth: number, mobileWidth?: number): number => {
    if (isMobile && mobileWidth) {
      return mobileWidth;
    }
    if (isTablet) {
      return Math.max(baseWidth * 0.8, 100);
    }
    return baseWidth;
  };

  const getPageSize = (): number => {
    if (isMobile) return 10;
    if (isTablet) return 15;
    return 100;
  };

  const getCardSpacing = (): number => {
    if (isMobile) return 2;
    if (isTablet) return 2.5;
    return 3;
  };

  return {
    isMobile,
    isTablet,
    isDesktop,
    getColumnWidth,
    getPageSize,
    getCardSpacing,
  };
};

export const getOptimizedDataGridProps = (responsive: ResponsiveConfig) => ({
  autoHeight: true,
  disableColumnMenu: !responsive.isDesktop,
  disableColumnSelector: responsive.isMobile,
  disableDensitySelector: responsive.isMobile,
  disableColumnFilter: responsive.isMobile,
  hideFooterSelectedRowCount: responsive.isMobile,
  pageSize: responsive.getPageSize(),
  rowsPerPageOptions: responsive.isMobile 
    ? [5, 10] 
    : responsive.isTablet 
    ? [10, 15, 25] 
    : [10, 25, 50, 100],
  sx: {
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f5f5f5",
      fontSize: responsive.isMobile ? "0.75rem" : "0.875rem",
    },
    "& .MuiDataGrid-cell": {
      fontSize: responsive.isMobile ? "0.75rem" : "0.875rem",
      padding: responsive.isMobile ? "4px 8px" : "8px 16px",
    },
    "& .MuiDataGrid-row": {
      minHeight: responsive.isMobile ? 40 : 52,
    },
    "& .MuiDataGrid-toolbarContainer": {
      display: responsive.isMobile ? "none" : "flex",
    },
  },
});